import config from '../config.json';

export const get = (key) => {
	try {
		const splitKeys = key.split('.');

		const configBaseLocation = config[process.env.REACT_APP_STAGE];
		let keyLocation = configBaseLocation;

		splitKeys.forEach(splitKey => {
			keyLocation = keyLocation[splitKey];
		});

		if (keyLocation) {
			return keyLocation;
		}

		return undefined;
	} catch (e) {
		console.log('Unable to get config key', e);
		return undefined;
	}
};
